import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface StreamingMessageProps {
  content: string;
}

export function StreamingMessage({ content }: StreamingMessageProps) {
  return (
    <div className="flex gap-3 animate-in fade-in slide-in-from-bottom-2">
      {/* AI Avatar */}
      <img
        src="/logo-chat.png"
        alt="KI"
        className="h-8 w-8 shrink-0 rounded-full object-cover"
      />

      {/* Message content */}
      <div className="flex-1 max-w-[85%]">
        <div className="rounded-lg px-4 py-3 bg-transparent">
          {content ? (
            <div className="prose prose-sm dark:prose-invert max-w-none break-words">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
              </ReactMarkdown>
              <span className="inline-block w-2 h-4 ml-0.5 bg-primary animate-pulse" />
            </div>
          ) : (
            <p className="text-sm">
              <span className="inline-flex gap-1">
                <span className="animate-bounce delay-0">.</span>
                <span className="animate-bounce delay-100">.</span>
                <span className="animate-bounce delay-200">.</span>
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
